// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__6l-Bl","text":"styles_text__36IOU","value":"styles_value__30Bjh"};